import { useEffect, useState } from 'react';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * Mirrors the active Regask theme onto the document root as
 * `.regask-light` / `.regask-dark`, so the Tailwind design-system tokens
 * (components/ui) follow the same dark/light selection as the MUI theme —
 * including react-aria popovers/menus that portal to <body>. Renders nothing;
 * mounted once via the sidebar (always present).
 */
export const ThemeClassSync = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const [themeId, setThemeId] = useState(appThemeApi.getActiveThemeId());

  useEffect(() => {
    const subscription = appThemeApi
      .activeThemeId$()
      .subscribe(id => setThemeId(id));
    return () => subscription.unsubscribe();
  }, [appThemeApi]);

  useEffect(() => {
    const root = document.documentElement;
    const dark = themeId !== 'light';
    root.classList.toggle('regask-dark', dark);
    root.classList.toggle('regask-light', !dark);
  }, [themeId]);

  return null;
};
